// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title___1NkbQ","subTitle":"styles__subTitle___2SNc9"};